var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isWeixin || _vm.forceContinue
    ? _c("div", { attrs: { id: "app" } }, [_c("router-view")], 1)
    : _c("div", { staticClass: "weixin-tip" }, [
        _c("div", { staticClass: "tip-card" }, [
          _c("div", { staticClass: "tip-icon" }, [_vm._v("🌐")]),
          _c("h2", [_vm._v("检测到您在微信中打开")]),
          _c("p", { staticClass: "tip-desc" }, [
            _vm._v(
              "部分功能在微信内置浏览器中可能无法正常使用，建议使用系统浏览器访问以获得完整体验。"
            ),
          ]),
          _c("div", { staticClass: "tip-actions" }, [
            _c(
              "button",
              { staticClass: "btn-primary", on: { click: _vm.openInBrowser } },
              [_vm._v(" 使用系统浏览器打开 ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn-secondary",
                on: { click: _vm.continueAnyway },
              },
              [_vm._v(" 继续在微信中访问 ")]
            ),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }